import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import moment from "moment";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import SiteZipSearchModal from "./SiteZipSearchModal";
import SiteFieldSearchModal from "./SiteFieldSearchModal";
import R0LearningCenterInformation from "./registrationSteps/R0LearningCenterInformation";
import R1SummerSession from "./registrationSteps/R1SummerSession";
import R2StudentInformation from "./registrationSteps/R2StudentInformation";
import R3ParentInformation from "./registrationSteps/R3ParentInformation";
import R4PhysicalAddress from "./registrationSteps/R4PhysicalAddress";
import R5MailingAddress from "./registrationSteps/R5MailingAddress";
import R6Ethnicity from "./registrationSteps/R6Ethnicity";
import R7PreviousSchoolInformation from "./registrationSteps/R7PreviousSchoolInformation";
import R8PrimaryLanguage from "./registrationSteps/R8PrimaryLanguage";
import R9HomeLanguage from "./registrationSteps/R9HomeLanguage";
import R10MigrantEducation from "./registrationSteps/R10MigrantEducation";
import R11ReleaseRequests from "./registrationSteps/R11ReleaseRequests";
import R12DassInformation from "./registrationSteps/R12DassInformation";
import R13HomeSurvey from "./registrationSteps/R13HomeSurvey";
import R14HealthConditions from "./registrationSteps/R14HealthConditions";
import R15ParentCustodyInformation from "./registrationSteps/R15ParentCustodyInformation";
import R16EmergencyContacts from "./registrationSteps/R16EmergencyContacts";
import R22StudentPrefrences from "./registrationSteps/R22StudentPrefrences";
import R33Parent2Information from "./registrationSteps/R33Parent2Information";
import ProgressLevelBar from "./ProgressLevelBar";
import ErrorLogger from "../ErrorLogger";
import { brandDomains, fetchBrands } from "../brand";

import checkValidation from "../../functions/checkValidation";

const RegistrationFormEdit = ({
  formData,
  setShowFormEdit,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const {
    setFormModal,
    formModal: { siteZipSearchModal, siteFieldSearchModal },
    updateRegistrationForm,
    setNotificationBanner,
    orientation_info,
  } = adminRegistrationContext;

  useEffect(() => {
    const loadBrands = async () => {
      await fetchBrands();
    };

    loadBrands();
  }, []);

  const brand_holston = brandDomains.brand_holston?.name;
  const brand_pbia = brandDomains.brand_pbia?.name;

  const [validationCheck, setValidationCheck] = useState(false);
  const {
    _id,
    status,
    programs,
    programDescription,
    progressLevel,
    processingLevel,
    registerForIntercession,
    previouslyEnrolled,
    firstName,
    middleName,
    lastName,
    haveSuffix,
    suffix,
    gender,
    birthDate,
    age,
    gradeLevel,
    birthState,
    birthCountry,
    studentEmail,
    studentPrimaryPhone,
    studentPrimaryPhoneType,
    pgHighestLevelOfEducation,
    permissionParentContact,
    pgRelationshipToStudent,
    pgFirstName,
    pgLastName,
    pgPrimaryPhone,
    pgPrimaryPhoneType,
    pgPrimaryEmail,
    liveWithPg,
    livingStatus,
    pg2HighestLevelOfEducation,

    pg2RelationshipToStudent,
    pg2FirstName,
    pg2LastName,
    pg2PrimaryPhone,
    pg2PrimaryPhoneType,
    pg2PrimaryEmail,
    liveWithPg2,
    street,
    city,
    state,
    zip,
    county,
    studentName,
    preferredpronouns,
    otherpreferredpronouns,
    isMailingAddressTheSame,
    mailingStreet,
    mailingCity,
    mailingState,
    mailingZip,
    mailingCountry,
    isStudentHispanicOrLatino,
    primaryRaceCategory,
    previousSchool,
    previousSchoolCity,
    previousSchoolState,
    primaryLanguage,
    firstLanguage,
    homeLanguage,
    languageSpokenByParentsToStudent,
    languageSpokenByAdultsAtHome,
    isPgEmployedInOneOrMoreAgriculturalOrFishingActivities,
    releaseAudioAndVideo,
    releasePermissionForSocialMedia,
    releaseUseStudentWork,
    releasePermissionToTextStudent,
    releasePermissionToTextPg,
    releaseAllowStudentAccessToGoogleAppsForEducation,
    beenExpelled,
    expelledFromWhichSchool,
    expelledWhatYear,
    beenSuspended,
    suspendedFromWhichSchool,
    suspendedWhatYear,
    onProbation,
    isParentOrExpecting,
    moreThanThreeUnexcusedAbsences,
    lateToSchoolMoreThanThreeTimes,
    orderedToAttendSchool,
    orderedToAttendWhichSchool,
    orderedToAttendWhatYear,
    retainedMoreThanOnce,
    retainedFromWhichSchool,
    retainedFromWhatYear,
    droppedOutOfSchool,
    droppedOutFromWhichSchool,
    droppedOutFromWhatYear,
    behindSemesterInCredits,
    outOfSchoolMoreThanFortyFiveDays,
    expelledMoreThanTwoSchoolsPastYear,
    fosterCare,
    youthExperiencingHomelessness,
    accessToComputerAtHome,
    accessToTheInternetAtHome,
    knownHealthConditions,
    asthma,
    beeStingAllergy,
    diabetes,
    epilepsy,
    heartCondition,
    seizures,
    nutAllergy,
    knownHearingConditions,
    wearsHearingAid,
    knownEyeCondition,
    glassesToBeWornAtAllTimes,
    wearsContactLenses,
    wearsGlasses,
    medications,
    otherHealthCondition,
    medicalInstructions,
    heathInsuranceCarrier,
    insuranceIdOrPolicyNumber,
    hospitalPreference,
    custodyIssueExists,
    custodyIssueNotes,
    legalRestrictionsForAnyParent,
    legalRestrictionsNotes,
    emergencyContact1FirstName,
    emergencyContact1LastName,
    emergencyContact1Phone,
    emergencyContact1Relationship,
    authorizedForPickup1,
    emergencyContact2FirstName,
    emergencyContact2LastName,
    emergencyContact2Phone,
    emergencyContact2Relationship,
    authorizedForPickup2,
    learningCenterId,
    learningCenterName,
    learningCenterCharter,
    learningCenterAddress,
    learningCenterCoordinates,
    orientationType,
    orientationTime,
    orientationLink,
    orientationScheduled,
    generalRegistrationNotes,
  } = formData;
  const [dateOfBirth, setDateOfBirth] = useState(
    moment(birthDate).utc().format("yyyy-MM-DD")
  );
  const [newFormData, setNewFormData] = useState({
    progressLevel,
    processingLevel,
    status,
    registerForIntercession,
    previouslyEnrolled,
    firstName,
    middleName,
    lastName,
    haveSuffix: { yes: haveSuffix, no: !haveSuffix },
    suffix,
    gender,
    age,
    gradeLevel,

    birthState,
    birthCountry,
    studentEmail,
    studentPrimaryPhone,
    studentPrimaryPhoneType,
    pgHighestLevelOfEducation,
    permissionParentContact: {
      yes: permissionParentContact,
      no: !permissionParentContact,
    },
    studentName,
    preferredpronouns,
    otherpreferredpronouns,
    pgRelationshipToStudent,
    pgFirstName,
    pgLastName,
    pgPrimaryPhone,
    pgPrimaryPhoneType,
    pgPrimaryEmail,
    liveWithPg: { yes: liveWithPg, no: !liveWithPg },
    pg2HighestLevelOfEducation,
    pg2RelationshipToStudent,
    pg2FirstName,
    pg2LastName,
    pg2PrimaryPhone,
    pg2PrimaryPhoneType,
    pg2PrimaryEmail,
    liveWithPg2: { yes: liveWithPg2, no: !liveWithPg2 },
    livingStatus,
    street,
    city,
    state,
    zip,
    county,
    isMailingAddressTheSame: {
      yes: isMailingAddressTheSame,
      no: !isMailingAddressTheSame,
    },
    mailingStreet,
    mailingCity,
    mailingState,
    mailingZip,
    mailingCountry,
    isStudentHispanicOrLatino: {
      yes: isStudentHispanicOrLatino,
      no: !isStudentHispanicOrLatino,
    },
    primaryRaceCategory,
    previousSchool,
    previousSchoolCity,
    previousSchoolState,
    primaryLanguage,
    firstLanguage,
    homeLanguage,
    languageSpokenByParentsToStudent,
    languageSpokenByAdultsAtHome,
    isPgEmployedInOneOrMoreAgriculturalOrFishingActivities: {
      yes: isPgEmployedInOneOrMoreAgriculturalOrFishingActivities,
      no: !isPgEmployedInOneOrMoreAgriculturalOrFishingActivities,
    },
    releaseAudioAndVideo: {
      yes: releaseAudioAndVideo,
      no: !releaseAudioAndVideo,
    },
    releasePermissionForSocialMedia: {
      yes: releasePermissionForSocialMedia,
      no: !releasePermissionForSocialMedia,
    },
    releaseUseStudentWork: {
      yes: releaseUseStudentWork,
      no: !releaseUseStudentWork,
    },
    releasePermissionToTextStudent: {
      yes: releasePermissionToTextStudent,
      no: !releasePermissionToTextStudent,
    },
    releasePermissionToTextPg: {
      yes: releasePermissionToTextPg,
      no: !releasePermissionToTextPg,
    },
    releaseAllowStudentAccessToGoogleAppsForEducation: {
      yes: releaseAllowStudentAccessToGoogleAppsForEducation,
      no: !releaseAllowStudentAccessToGoogleAppsForEducation,
    },
    beenExpelled: { yes: beenExpelled, no: !beenExpelled },
    expelledFromWhichSchool,
    expelledWhatYear,
    beenSuspended: { yes: beenSuspended, no: !beenSuspended },
    suspendedFromWhichSchool,
    suspendedWhatYear,
    onProbation: { yes: onProbation, no: !onProbation },
    isParentOrExpecting: { yes: isParentOrExpecting, no: !isParentOrExpecting },
    moreThanThreeUnexcusedAbsences: {
      yes: moreThanThreeUnexcusedAbsences,
      no: !moreThanThreeUnexcusedAbsences,
    },
    lateToSchoolMoreThanThreeTimes: {
      yes: lateToSchoolMoreThanThreeTimes,
      no: !lateToSchoolMoreThanThreeTimes,
    },
    orderedToAttendSchool: {
      yes: orderedToAttendSchool,
      no: !orderedToAttendSchool,
    },
    orderedToAttendWhichSchool,
    orderedToAttendWhatYear,
    retainedMoreThanOnce: {
      yes: retainedMoreThanOnce,
      no: !retainedMoreThanOnce,
    },
    retainedFromWhichSchool,
    retainedFromWhatYear,
    droppedOutOfSchool: { yes: droppedOutOfSchool, no: !droppedOutOfSchool },
    droppedOutFromWhichSchool,
    droppedOutFromWhatYear,
    behindSemesterInCredits: {
      yes: behindSemesterInCredits,
      no: !behindSemesterInCredits,
    },
    outOfSchoolMoreThanFortyFiveDays: {
      yes: outOfSchoolMoreThanFortyFiveDays,
      no: !outOfSchoolMoreThanFortyFiveDays,
    },
    expelledMoreThanTwoSchoolsPastYear: {
      yes: expelledMoreThanTwoSchoolsPastYear,
      no: !expelledMoreThanTwoSchoolsPastYear,
    },
    fosterCare: { yes: fosterCare, no: !fosterCare },
    youthExperiencingHomelessness: {
      yes: youthExperiencingHomelessness,
      no: !youthExperiencingHomelessness,
    },
    accessToComputerAtHome: {
      yes: accessToComputerAtHome,
      no: !accessToComputerAtHome,
    },
    accessToTheInternetAtHome: {
      yes: accessToTheInternetAtHome,
      no: !accessToTheInternetAtHome,
    },
    knownHealthConditions: {
      yes: knownHealthConditions,
      no: !knownHealthConditions,
    },
    asthma: { yes: asthma, no: !asthma },
    beeStingAllergy: { yes: beeStingAllergy, no: !beeStingAllergy },
    diabetes: { yes: diabetes, no: !diabetes },
    epilepsy: { yes: epilepsy, no: !epilepsy },
    heartCondition: { yes: heartCondition, no: !heartCondition },
    seizures: { yes: seizures, no: !seizures },
    nutAllergy: { yes: nutAllergy, no: !nutAllergy },
    knownHearingConditions: {
      yes: knownHearingConditions,
      no: !knownHearingConditions,
    },
    wearsHearingAid: { yes: wearsHearingAid, no: !wearsHearingAid },
    knownEyeCondition: { yes: knownEyeCondition, no: !knownEyeCondition },
    glassesToBeWornAtAllTimes: {
      yes: glassesToBeWornAtAllTimes,
      no: !glassesToBeWornAtAllTimes,
    },
    wearsContactLenses: { yes: wearsContactLenses, no: !wearsContactLenses },
    wearsGlasses: { yes: wearsGlasses, no: !wearsGlasses },
    medications,
    otherHealthCondition,
    medicalInstructions,
    heathInsuranceCarrier,
    insuranceIdOrPolicyNumber,
    hospitalPreference,
    custodyIssueExists: { yes: custodyIssueExists, no: !custodyIssueExists },
    custodyIssueNotes,
    legalRestrictionsForAnyParent: {
      yes: legalRestrictionsForAnyParent,
      no: !legalRestrictionsForAnyParent,
    },
    legalRestrictionsNotes,
    emergencyContact1FirstName,
    emergencyContact1LastName,
    emergencyContact1Phone,
    emergencyContact1Relationship,
    authorizedForPickup1: {
      yes: authorizedForPickup1,
      no: !authorizedForPickup1,
    },
    emergencyContact2FirstName,
    emergencyContact2LastName,
    emergencyContact2Phone,
    emergencyContact2Relationship,
    authorizedForPickup2: {
      yes: authorizedForPickup2,
      no: !authorizedForPickup2,
    },
    learningCenterName,
    learningCenterCharter,
    learningCenterAddress,
    learningCenterCoordinates,
    learningCenterId,
    orientationScheduled,
    orientationType,
    orientationTime,
    orientationLink,
    generalRegistrationNotes,
  });

  const selectEnrollmentType = (type) => {
    setNewFormData({
      ...newFormData,
      registerForIntercession: type === "REGULAR" ? false : true,
    });
  };

  const setLanguageToEnglish = () => {
    setNewFormData({
      ...newFormData,
      firstLanguage: "English",
      homeLanguage: "English",
      languageSpokenByParentsToStudent: "English",
      languageSpokenByAdultsAtHome: "English",
    });
  };

  const getAge = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var newAge = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      newAge--;
    }
    setNewFormData({ ...newFormData, age: newAge });
  };

  const setLocationInfo = (info) => {
    setNewFormData({
      ...newFormData,
      learningCenterId: info.id,
      learningCenterName: info.name,
      learningCenterCharter: info.charter,
      learningCenterAddress: info.address,
      learningCenterCoordinates: info.coordinates,
    });
  };

  const handleOnChange = (e) => {
    if (e.target.type === "date") {
      setDateOfBirth(e.target.value);
    } else {
      setNewFormData({
        ...newFormData,
        [e.target.name]:
          e.target.type === "radio"
            ? e.target.name === "previouslyEnrolled"
              ? e.target.value === "yes"
                ? { yes: true, no: false, "not sure": false }
                : e.target.value === "no"
                ? { yes: false, no: true, "not sure": false }
                : { yes: false, no: false, "not sure": true }
              : e.target.value === "yes"
              ? { yes: true, no: false }
              : { yes: false, no: true }
            : e.target.value,
      });
    }
  };
  const brandName = orientation_info.brandName;
  
  const handleSubmitChanges = async () => {
    checkValidation(
      { ...newFormData, birthDate: dateOfBirth },
      setValidationCheck
    );
    try {
      if (
        !checkValidation(
          { ...newFormData, birthDate: dateOfBirth },
          setValidationCheck
        )
      ) {
        setValidationCheck(false);
        await updateRegistrationForm(_id, {
          ...newFormData,
          birthDate: dateOfBirth,
        });
        setNotificationBanner("success", `Registration has been updated`);
        setShowFormEdit(false);
      }
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  if ((brandName && brandName.toLowerCase() === brand_holston) || (brandName && brandName === brand_pbia)) {
    return (
      <section className="interest-form-edit">
        {siteFieldSearchModal && (
          <SiteFieldSearchModal setLocationInfo={setLocationInfo} />
        )}
        {siteZipSearchModal && (
          <SiteZipSearchModal setLocationInfo={setLocationInfo} />
        )}
        <div className="top-bar">
          <div
            onClick={() => {
              typeof location.state === "undefined"
                ? navigate(`/registration-forms`)
                : navigate(location.state.from);
            }}
            className="left"
          >
            <FaIcons.FaArrowLeft className="menu-icon" />
            <span>Go Back</span>
          </div>
        </div>
        <ProgressLevelBar level={progressLevel} />
        <h2 className="top-title text-center">Enrollment Registration Form</h2>
        <div className="edit-btn" onClick={() => setShowFormEdit(false)}>
          <p>Cancel Edit</p>
          <FaIcons.FaWindowClose className="edit-icon" />
        </div>
        <div className="form">
          <div className="search-modal-btns">
            <div
              onClick={() => setFormModal("siteZipSearchModal", true)}
              className="btn btn-llac-light-green"
            >
              Search Site by Zip
            </div>
            <div
              onClick={() => setFormModal("siteFieldSearchModal", true)}
              className="btn btn-llac-light-green"
            >
              Search Site by Fields
            </div>
          </div>
          <div className="btn-container">
            <div
              onClick={() => handleSubmitChanges()}
              className="btn btn-llac-dark-green top-submit-btn"
            >
              Submit Changes
            </div>
          </div>
          <R0LearningCenterInformation
            formData={newFormData}
            validationCheck={validationCheck}
          />
          <div className="sub-form">
            <h3>Registration Notes</h3>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  {firstName === "" ? "the Student" : firstName}'s Registration
                  Notes
                </h4>
                {/* <FaIcons.FaAsterisk className="asterisk-icon" /> */}
              </div>
              <textarea
                cols="30"
                rows="4"
                name="generalRegistrationNotes"
                onChange={(e) => {
                  handleOnChange(e);
                }}
              >
                {generalRegistrationNotes}
              </textarea>
            </div>
          </div>
          <R2StudentInformation
            formData={{ ...newFormData, birthDate: dateOfBirth }}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
            getAge={getAge}
          />

          <R22StudentPrefrences
            formData={{ ...newFormData, birthDate: dateOfBirth }}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
            getAge={getAge}
          />
          <R3ParentInformation
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />

          <R33Parent2Information
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R4PhysicalAddress
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R5MailingAddress
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R6Ethnicity
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R7PreviousSchoolInformation
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R8PrimaryLanguage
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />

          <R11ReleaseRequests
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />

          <R15ParentCustodyInformation
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />

          <div
            onClick={() => handleSubmitChanges()}
            className="btn btn-llac-dark-green submit-change-btn"
          >
            Submit Changes
          </div>
        </div>
      </section>
    );
  } else {
    return (
      <section className="interest-form-edit">
        {siteFieldSearchModal && (
          <SiteFieldSearchModal setLocationInfo={setLocationInfo} />
        )}
        {siteZipSearchModal && (
          <SiteZipSearchModal setLocationInfo={setLocationInfo} />
        )}
        <div className="top-bar">
          <div
            onClick={() => {
              typeof location.state === "undefined"
                ? navigate(`/registration-forms`)
                : navigate(location.state.from);
            }}
            className="left"
          >
            <FaIcons.FaArrowLeft className="menu-icon" />
            <span>Go Back</span>
          </div>
        </div>
        <ProgressLevelBar level={progressLevel} />
        <h2 className="top-title text-center">Enrollment Registration Form</h2>
        <div className="edit-btn" onClick={() => setShowFormEdit(false)}>
          <p>Cancel Edit</p>
          <FaIcons.FaWindowClose className="edit-icon" />
        </div>
        <div className="form">
          <div className="search-modal-btns">
            <div
              onClick={() => setFormModal("siteZipSearchModal", true)}
              className="btn btn-llac-light-green"
            >
              Search Site by Zip
            </div>
            <div
              onClick={() => setFormModal("siteFieldSearchModal", true)}
              className="btn btn-llac-light-green"
            >
              Search Site by Fields
            </div>
          </div>
          <div className="btn-container">
            <div
              onClick={() => handleSubmitChanges()}
              className="btn btn-llac-dark-green top-submit-btn"
            >
              Submit Changes
            </div>
          </div>
          <R0LearningCenterInformation
            formData={newFormData}
            validationCheck={validationCheck}
          />
          {/* <R1SummerSession
              formData={newFormData}
              onFormDataChange={handleOnChange}
              validationCheck={validationCheck}
              selectEnrollmentType={selectEnrollmentType}
            /> */}
          <div className="sub-form">
            <h3>Registration Notes</h3>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  {firstName === "" ? "the Student" : firstName}'s Registration
                  Notes
                </h4>
                {/* <FaIcons.FaAsterisk className="asterisk-icon" /> */}
              </div>
              <textarea
                cols="30"
                rows="4"
                name="generalRegistrationNotes"
                onChange={(e) => {
                  handleOnChange(e);
                }}
              >
                {generalRegistrationNotes}
              </textarea>
            </div>
          </div>
          <R2StudentInformation
            formData={{ ...newFormData, birthDate: dateOfBirth }}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
            getAge={getAge}
          />

          <R3ParentInformation
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R4PhysicalAddress
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R5MailingAddress
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R6Ethnicity
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R7PreviousSchoolInformation
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R8PrimaryLanguage
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R9HomeLanguage
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
            setLanguageToEnglish={setLanguageToEnglish}
          />

          <R11ReleaseRequests
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R12DassInformation
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R13HomeSurvey
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R14HealthConditions
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R15ParentCustodyInformation
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <R16EmergencyContacts
            formData={newFormData}
            onFormDataChange={handleOnChange}
            validationCheck={validationCheck}
          />
          <div
            onClick={() => handleSubmitChanges()}
            className="btn btn-llac-dark-green submit-change-btn"
          >
            Submit Changes
          </div>
        </div>
      </section>
    );
  }
};

export default RegistrationFormEdit;
